import "@src/services/echo";
import { useAuthStore } from "@src/stores/auth";
import { useChatSessionStore } from "@src/stores/chatSession";
import { db } from "@src/services/db";

type EndSessionPayload = {
    session: { id: number };
};

export function EndSessionListener() {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    // você precisa do company_id no user (ou pegar via endpoint /user)
    const companyId = (auth.user as any)?.company_id;
    if (!companyId) {
        console.warn("EndSessionListener: user sem company_id");
        return;
    }

    // @ts-ignore
    window.websockets
        .private(`company.${companyId}`)
        .listen(".EndSessionEvent", async (event: EndSessionPayload) => {
            try {
                const sessionId = Number(event?.session?.id);
                if (!sessionId) return;

                // remove do IndexedDB -> liveQuery atualiza listas automaticamente
                await db.sessions.delete(sessionId);

                // se estiver aberto, fecha
                if (sessionStore.type === "session" && sessionStore.selectedSession?.id === sessionId) {
                    sessionStore.clearSession();
                }
            } catch (e) {
                console.error("❌ erro no listener EndSessionEvent", e);
            }
        });
}